const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/items/$id/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/{-$locale}/items/$id/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});